import { render, staticRenderFns } from "./AppHorizontalSlideController.vue?vue&type=template&id=5266e96d&scoped=true&"
import script from "./AppHorizontalSlideController.vue?vue&type=script&lang=ts&"
export * from "./AppHorizontalSlideController.vue?vue&type=script&lang=ts&"
import style0 from "./AppHorizontalSlideController.vue?vue&type=style&index=0&id=5266e96d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5266e96d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
